import _colors from '../colors';

const buttonStyleCommon = {
  border: '2px solid',
  height: '30px',
  lineHeight: '26px',
  padding: '0 12px',
};

const defaultColors = {
  backgroundColor: _colors.backgroundColorDefault,
  borderColor: _colors.backgroundColorDefault,
  color: _colors.textColorPrimary,
};

const buttonRadius = {
  borderRadius: '20px',
};

const defaultButton = {
  ...buttonStyleCommon,
  ...defaultColors,
  labelStyle: {
    fontWeight: 'bold',
  },
};

const fullWidth = {
  width: '100%',
};

const { rippleColor } = _colors;

export default {
  defaultButton,
  buttonRadius,
  fullWidth,
  rippleColor,
};
